<template>
  <div class="informationinfo"
    style="font-family: -apple-system-font,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      <video id="" autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto">
        <!-- <source type="video/mp4" src="../assets/images/banner.mp4" /> -->
      </video>
    </div>
    <div>
      <div class="box">
        <div style="font-size: 0.12rem !important; padding-top: 10px">
          <el-breadcrumb style="font-size: 0.12rem !important" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Information' }"
              style="font-size: 0.12rem !important">平台资讯</el-breadcrumb-item>
            <el-breadcrumb-item style="font-size: 0.12rem !important">新闻详情</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button style="position: relative; left: 100%;border:2px solid #409EFF;font-weight:bold" size="mini"
            type="text" plain @click="tag = tag == 'cn' ? 'us' : 'cn'">{{ tag == "cn" ? "English" : "中文" }}</el-button>
        </div>
        <br />
        <div v-if="tag == 'cn'">
          <div style="font-size: 0.24rem; font-weight: bold; width: 100%; text-align: center">
            《环卫产业互联网平台白皮书（2020）》正式发布！
          </div>

          <div style="
              font-size: 0.14rem;
              padding: 0.1rem 0;
              color: #aaa;
              width: 100%;
              text-align: center;
            ">
            <i class="el-icon-time"></i>2020年11月22日
          </div>
          <div style="width: 100%; text-align: center">
            <!-- <el-button type="text" @click="openDialog"
              >《环卫产业互联网平台白皮书（2020）》下载</el-button
            > -->
            <a href="#" style="color:#409EFF" @click="openDialog">
              《环卫产业互联网平台白皮书（2020）》下载
            </a>
          </div>
          <br />
          <div class="article lh-36">
            发展工业互联网是第四次工业革命的重要基石。工业互联网是新一代信息技术与工业经济深度融合的全新工业生态，可促进生产力变革，使生产过程降本、增效和提质。
          </div>
          <div class="article lh-36">
            近日，由中国城市环境卫生协会（以下简称“中环协”）牵头，在多位行业领导和专家指导下，智慧环卫专委会联合多家行业优秀企业编制的，环卫行业第一本白皮书——《环卫产业互联网平台白皮书（2020）》正式发布，是工业互联网与环卫产业融合的标志。
          </div>
          <div class="article lh-36">
            白皮书立足于国家智能化和网络化的发展战略，结合环卫产业的实际情况和发展趋势，历经一年的调查研究撰写的专题性研究报告，旨在呼吁社会各界共同关注智能+环卫产业的政策研究、技术投入、标准建设与服务应用，共同推动环卫产业的创新发展。
          </div>
          <!-- <el-col :span="12" style="text-align: right">
              <img style="width: 40%;margin-top:  -25px" src="../assets/images/book1.jpg" />
            </el-col> -->
          <div style="width:100%;text-align:center;padding:20px 0">
            <img style="width: 40%" src="../assets/images/book.jpg" />
          </div>
          <div class="article lh-36">
            白皮书由前言、现状、平台、架构、设计、标准与建议七个部分组成。通过研究环卫智能化发展现状，提出了环卫产业互联网平台的概念，梳理了与关联产业的关系，描述了环卫产业互联网平台的宏伟蓝图。同时，基于不断创新的技术和产业发展前瞻性需求，提出了环卫产业互联网平台的相关标准体系，以期为平台落地应用和战略部署提供技术支撑，为下一步工作落实理清思路。
          </div>
          <div class="article lh-36">
            环卫产业互联网平台是面向环卫产业数字化、网络化、智能化需求，构建基于海量数据采集、汇聚、分析的服务体系，支撑产业资源泛在连接、弹性供给、高效配置的云平台。环卫产业互联网平台是数字时代各垂直产业的新型基础设施，应由产业中的优秀企业牵头建设，以共享经济的方式提供给产业生态中广大的从业者使用。从整个产业链的角度，整合资源和优化价值链，降低产业运营成本，提高全产业运营质量与效率，通过新的产业生态为客户创造更好的体验和社会价值。
          </div>
          <div class="article lh-36">
            白皮书提出环卫产业互联网平台以“创造新价值”为核心，开创性的采用“共享增效”的盈利模式，以及“大平台+多中心”的建设模式。平台所有主体以用户价值共创和共享为原则，以分增效的方式运行，为终端用户实现降本增收和提质服务。平台主导者青岛国真智慧科技有限公司积极响应中环协的号召，主动担当环卫行业平台建设前期开发和后期统筹服务工作，在智慧环卫专委会指导下，组织细分行业优秀企业作为中心主导者，共同开展行业网络平台建设与应用。
          </div>
          <div class="article lh-36">
            环卫产业覆盖范围较广，本次白皮书重点围绕生活垃圾分类与回收、清运与处理等环节开展研究与设计，中环协智慧环卫专委会后续将持续开展其他细分领域的深入研究，研究成果展现与发布形式，将遵照行业主管部门的指导意见进行改进，并充分听取社会各界专业人士的建议，将成果向全行业公开，敬请期待。
          </div>
          <!-- <br />
          <div class="lh-35">
            白皮书目录：<br />
            第一章 前言<br />
            1.1 背景分析<br />
            1.2 目标意义<br />
            第二章 现状<br />
            2.1 政策支撑<br />
            2.2 主要成果<br />
            2.3 机遇挑战<br />
            第三章 平台<br />
            3.1 概念与边界<br />
            3.2 主体关系<br />
            3.3 用户体系<br />
            3.4 建设模式<br />
            3.5 盈利模式<br />
            3.6 实施计划<br />
            第四章 架构<br />
            4.1 结构内容<br />
            4.2 边缘层<br />
            4.3 IaaS层<br />
            4.4 PaaS层<br />
            4.5 SaaS层<br />
            4.6 安全防护<br />
            第五章 标准<br />
            5.1 基础条件<br />
            5.2 标准体系<br />
            5.3 实施路径<br />
            第六章 应用<br />
            6.1 垃圾分类与回收<br />
            6.2 垃圾清扫与清运<br />
            6.3 垃圾处理与利用<br />
            第七章 建议<br />
            7.1 政府<br />
            7.2 企业<br />
            7.3 其他
          </div> -->
          <br />
          <div @click="tag = 'us'" v-if="tag = 'cn'" style="color:#409EFF">
            英文版获取请点击此处
          </div>
          <br />

          <div class="lh-36">
            版权声明：本白皮书版权属于中国城市环境卫生协会，并受法律保护。转载、摘编或利用其它方式使用本白皮书文字或观点，请注明“来源：中国城市环境卫生协会”。违反上述声明者，将追究其相关法律责任。
          </div>
          <br />
          <br />
          <div class="lh-36">
            如有其他疑问，可与编制组联系，联系方式如下：<br />
            中环协智慧环卫专委会：zhihuihuanwei@126.com<br />
            主编：曹曼博士caoman@tianren.com<br />
            执行主编：吴健敏wujianmin@tianren.com<br />
          </div>
          <br />
        </div>
        <div v-if="tag == 'us'">
          <div style="width:100%;text-align:center">
            <span style="font-size: 0.24rem; font-weight: bold; width: 100%; text-align: center;font-style:italic">White
              Paper of Sanitation Industry Internet Platform (2020)
            </span>
            <span style="font-size: 0.24rem; font-weight: bold; width: 100%; text-align: center">is Now
              Available!</span>
          </div>

          <div style="
              font-size: 0.14rem;
              padding: 0.1rem 0;
              color: #aaa;
              width: 100%;
              text-align: center;
            ">
            <i class="el-icon-time"></i>November 22, 2020
          </div>
          <div style="width: 100%; text-align: center">
            <a href="#" style="border-bottom: 1px solid #409EFF; text-decoration: none;
" @click="openDialog">
              <span style="color:#409EFF;font-style:italic">White Paper of Sanitation Industry Internet Platform (2020)
              </span>
              <span style="color:#409EFF;">download</span>
            </a>
          </div>
          <br />
          <div class="article lh-36">
            The development of the industrial Internet is an important
            cornerstone of the fourth industrial revolution. The Industrial
            Internet is a new industrial ecology in which a new generation of
            information technology is deeply integrated with the industrial
            economy, which can promote productivity change, thus reducing
            production costs and achieving more efficient and high-quality
            production.
          </div>
          <div class="article lh-36">
            Recently, led by the China Association of Urban Environmental
            Sanitation (hereinafter referred to as "CAUES"), and under the
            guidance of a number of industry leaders and experts, the first
            white paper of the sanitation industry - White Paper of Sanitation
            Industry Internet Platform (2020) was officially released, which is
            a symbol of the integration of the industrial Internet and the
            sanitation industry.
          </div>
          <div class="article lh-36">
            The white paper is based on the national development strategy of
            smartization and networking and the actual situation and development
            trend of the sanitation industry, and is a thematic research report
            written after a year's investigation and research. It aims to call
            on all sectors of the society to pay attention to the policy
            research, technical input, standard construction and service
            application of the intelligent + sanitation industry, and jointly
            promote the innovative development of the sanitation industry.
          </div>
          <div style="width:100%;text-align:center;padding:20px 0">
            <img style="width: 40%" src="../assets/images/book.jpg" />
          </div>
          <div class="article lh-36">
            The white paper consists of seven sections: Preface, The Current
            Situation, Platforms, Structure, Design, Standards and
            Recommendations. By studying the current situation of the
            smartization of the sanitation industry, the concept of an Internet
            platform for the sanitation industry is put forward, the
            relationship with related industries is sorted out and a grand
            blueprint for an Internet platform for the sanitation industry is
            described. At the same time, based on the prospective needs of
            innovative technology and industrial development, a relevant
            standard system for the Internet platform for sanitation industry is
            proposed, in order to provide technical support for the platform's
            ground application and strategic deployment, and to clarify ideas
            for the next step of implementation.
          </div>
          <div class="article lh-36">
            The internet platform for the sanitation industry is a cloud
            platform for the digital, networked and smartized needs of the
            sanitation industry, which can build a service system based on
            massive data collection, aggregation and analysis, thus supporting
            the ubiquitous connection, flexible supply and efficient allocation
            of industrial resources. The Internet platform for the sanitation
            industry is a new infrastructure for vertical industries in the
            digital era, which should be built under the leadership of
            outstanding enterprises in the industry and provided to the majority
            of practitioners in the industrial ecology in the form of a sharing
            economy. From the perspective of the whole industry chain, it can
            integrate resources and optimise the value chain, reduce industrial
            operating costs, improve the quality and efficiency of the whole
            industry operation, and create better experience and social value
            for customers by taking advantage of the new industrial ecology.
          </div>
          <div class="article lh-36">
            The Internet platform for the sanitation industry proposed in the
            white paper is based on the core of "creating new value", and
            pioneers the profit model of "sharing and synergy" and the
            construction model of "big platform + multi-centre". All the
            platform subjects follow the principle of co-creation and sharing of
            user value, and operate in a way of dividing and increasing
            efficiency to achieve cost reduction and increase revenue for end
            users and improve quality of service. Qingdao Guozhen Smart
            Technology Co., the leader of the platform, actively responded to
            the call of the CAUES, and took the initiative to take charge of the
            platform's early development and late co-ordination work. Under the
            guidance of the Smart Sanitation Professional Committee, it
            organises the best companies in sub-sectors as central leaders in
            the construction and application of the internet platform.
          </div>
          <div class="article lh-36">
            As the sanitation industry covers a wide range of areas, the white
            paper focuses on the detailed research and design of domestic waste
            classification and recycling, sweeping, transportation and
            treatment, etc. China Association of Urban Sanitation Smart
            Sanitation Professional Committee will continue to carry out
            in-depth research in other sub-sectors, and the presentation and
            publication of research results will be improved in accordance with
            the guidelines of the authorities of the industry. We will listen to
            the suggestions of professionals from all walks of life and make the
            results available to the whole industry, so please stay tuned.
          </div>
          <!-- <br />
          <div class="lh-36">
            Contents of the White Paper：<br />
            Chapter 1 Preface<br />
            1.1 Background Analysis <br />
            1.2 Objectives and Significance <br />
            Chapter 2: The Current Situation<br />
            2.1 Policy Support<br />
            2.2 Main Achievements <br />
            2.3 Opportunities and Challenges <br />
            Chapter 3 Platforms<br />
            3.1 Concepts and Boundaries<br />
            3.2 Subject Relations<br />
            3.3 User System <br />
            3.4 Construction Models <br />
            3.5 Profit Models <br />
            3.6 Implementation Plan <br />
            Chapter 4 Structure<br />
            4.1 Structural Contents <br />
            4.2 Edge layer<br />
            4.3 IaaS Layer<br />
            4.4 PaaS Layer<br />
            4.5 SaaS Layer<br />
            4.6 Security <br />
            Chapter 5 Standards<br />
            5.1 General Conditions <br />
            5.2 Standard Systems<br />
            5.3 Implementation paths<br />
            Chapter 6 Applications<br />
            6.1 Waste Separation and Recycling<br />
            6.2 Waste Collection and Removal<br />
            6.3 Waste disposal and utilisation<br />
            Chapter 7 Recommendations<br />
            7.1 Government <br />
            7.2 Enterprises<br />
            7.3 Other Recommendations
          </div> -->
          <br />
          <div class="lh-36">
            Copyright notice: This white paper is copyrighted by the China
            Association of Urban Environmental Sanitation and is protected by
            law. If you reproduce, excerpt or otherwise use the text or ideas in
            this white paper, please indicate "Source: China Association of
            Urban Environmental Sanitation". Violators of the above statement
            will be prosecuted for their legal liability.
          </div>
          <br />
          <br />
          <div class="lh-36">
            If you have any further questions, you can contact the Compilation
            Team at the following address.<br />
            Smart Sanitation Professional Committee: zhihuihuanwei@126.com<br />
            Editor-in-chief：Dr. Cao Man caoman@tianren.com<br />
            Executive Editor：Wu Jianmin wujianmin@tianren.com<br />
          </div>
          <br />
        </div>
      </div>
    </div>
    <el-dialog title="下载" :width="allWidth < 750 ? '80%' : '30%'" :visible.sync="dialogFormVisible" v-if="dialogFormVisible">
      <el-form :model="form" :label-width="allWidth < 750 ? '80px' : '100px'" :rules="rules" ref="form"
        :size="allWidth < 750 ? 'mini' : 'small'">
        <el-form-item label="姓名" prop="askerName">
          <el-input v-model="form.askerName"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="askerPhone">
          <el-input v-model="form.askerPhone"></el-input>
        </el-form-item>
        <el-form-item label="企业名称" prop="companyName">
          <el-input v-model="form.companyName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机验证码" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="allWidth < 750 ? 'mini' : 'small'" @click="dialogFormVisible = false">取 消</el-button>
        <el-button :size="allWidth < 750 ? 'mini' : 'small'" type="primary" @click="download">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import count from "@/api/home.js";
import { addConsult } from "@/api/consult";
export default {
  name: "InformationInfo",
  data () {
    var checkPhone = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      allWidth: 0,
      tag: "cn",
      dialogFormVisible: false,
      form: {},

      rules: {
        askerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        askerPhone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "change" }
        ],
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        // code: [
        //   { required: true, message: "验证码", trigger: "blur" }
        // ]
      }
    };
  },
  created () { },
  mounted () {
    this.allWidth = document.documentElement.clientWidth
    console.log(document.documentElement.clientWidth)
  },
  methods: {
    //打开dialog框
    openDialog () {
      this.form = {
        askerName: "",
        askerPhone: "",
        companyName: "",
        questionDesp: "白皮书下载"
      };
      this.dialogFormVisible = true;
    },
    // 下载
    download () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.productName = "智能收运系统";
          this.form.productId = 56;
          addConsult(this.form).then(res => {
            if (res.code == 0) {
              window.open("api/pt/common/downloadFile?tag=" + this.tag);
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 0.32rem;
  padding: 0.24rem 0;
  text-align: center;
}

.box {
  padding: 0 4rem;
  height: auto;
}

.article {
  text-indent: 2em;
}

.lh-36 {
  // line-height: 0.36rem;
}

.lh-35 {
  // line-height: 0.25rem;
  font-size: 0.1rem;
  color: #949699;
}
</style>



// WEBPACK FOOTER //
// src/components/InformationInfo.vue